<template>
  <ChartLayout
    :title="title"
    units="billion USD"
    v-if="treeSeries && treeOptions"
  >
    <small v-if="mode === 'Country' && country !== 'All countries'">
      <a href="#" @click.prevent="$emit('select-country', 'All countries')"
        >&lt; Show all countries</a
      >
    </small>
    <Chart :options="treeOptions" />
    <template #footer>
      <ChartLegend
        v-if="mode !== 'Category'"
        :legendItems="
          categories.map((category) => ({
            name: category,
            colorIndex: categoryOrder.indexOf(category),
          }))
        "
        :hoverSeries="() => {}"
      />
    </template>
  </ChartLayout>
</template>

<script>
import ChartOptions, {
  ChartLayout,
  ChartLegend,
} from "@international-energy-agency/vue-ui/highcharts";
import { Chart } from "highcharts-vue";
import techsByCategory from "../data/techsByCategory";
export default {
  props: {
    filteredPolicyGroups: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      requird: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    largestBudget: {
      type: Number,
      required: true,
    },
  },
  components: {
    ChartLayout,
    ChartLegend,
    Chart,
  },
  data() {
    return {
      categoryOrder: Object.keys(techsByCategory),
    };
  },
  methods: {},
  computed: {
    title() {
      const { mode, category, country } = this;
      if (mode === "Country")
        return `${country}, government energy spending by category`;
      return `Government spending on ${category.toLowerCase()} by country`;
    },
    treeOptions() {
      return ChartOptions.buildOptions(
        {
          chart: {
            height: 600,
            spacingBottom: 20,
          },
          tooltip: {
            pointFormat:
              "{point.parent}<br><b>{point.name}:</b> {point.value:.1f} billion USD",
          },
          plotOptions: {
            treemap: {
              layoutAlgorithm: "squarified",
            },
          },
          series: this.treeSeries,
        },
        "treemap"
      );
    },
    treeSeries() {
      const {
        filteredPolicyGroups,
        categoryOrder,
        mode,
        country,
        category,
        largestBudget,
      } = this;
      return [
        {
          name: "All spending",
          type: "treemap",
          layoutAlgorithm: "squarified",
          // use 'native' drilldown on category mode
          /*
          allowTraversingTree: mode === "Category",
          breadcrumbs: {
            zIndex: 999,
            position: {
              align: "center",
              verticalAlign: "top",
              floating: true
            }
          },
          */
          // otherwise fire a select country event to select the country view
          events: {
            click: (e) => {
              this.$emit(
                "select-country",
                e.point.parent
                  ? e.point.parent.replace(/[-]+/g, " ")
                  : e.point.name
              );
            },
          },
          dataLabels: {
            enabled: true,
          },
          levels: [
            {
              level: 1,
              borderWidth: 3,
              dataLabels: {
                enabled:
                  (mode === "Country" && country === "All countries") ||
                  mode === "Category",
                align: "left",
                verticalAlign: "top",
              },
            },
            {
              level: 2,
              layoutAlgorithm: "squarified",
              dataLabels: {
                // don't show data labels in all countries view
                enabled:
                  (mode === "Country" && country !== "All countries") ||
                  mode === "Category",
                // small text for second-level labels except on country breakdown
                className:
                  mode === "Country" && country !== "All countries"
                    ? ""
                    : "highcharts-data-label-sm",
                crop: true,
                overflow: "justify",
                inside: true,
                filter: {
                  property: "value",
                  operator: ">",
                  value: largestBudget / 10,
                },
              },
            },
          ],
          data: filteredPolicyGroups
            .slice(0)
            .sort((a, b) => (a.country > b.country ? 1 : -1))
            .reduce((points, policyGroup) => {
              policyGroup.policies.forEach((policy) => {
                // handle category view
                if (mode === "Category" && category !== policy.category)
                  return points;
                const pointParentId = policy.country.replace(/[-\s]+/g, "-");
                const pointId = `${policy.category.replace(/[-\s]+/g, "-")}${
                  mode === "Category" ? policy.tech.replace(/[-\s]+/g, "-") : ""
                }${pointParentId}`;
                const parentPoint = points.find(
                  (point) => point.id === pointParentId
                );
                if (!parentPoint) {
                  // index += 1;
                  points.push({
                    name: policy.country,
                    id: pointParentId,
                    // colorIndex: index % 9
                  });
                }
                const existingSeries = points.find(
                  (point) =>
                    point.id === pointId && point.parent === pointParentId
                );
                if (existingSeries) {
                  existingSeries.value += policy.budgetUSD;
                } else {
                  points.push({
                    name: mode === "Category" ? policy.tech : policy.category,
                    id: pointId,
                    parent: pointParentId,
                    value: policy.budgetUSD,
                    colorIndex: categoryOrder.indexOf(policy.category),
                  });
                }
              });
              return points;
            }, []),
        },
      ];
    },
  },
};
</script>

<style>
.highcharts-data-label-sm {
  font-size: 9px;
  font-weight: normal;
}
</style>
